import { PlanType } from "@/commons/services/Plans";
import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";

/** store state model */
export interface MobileMessageRegisterState {
  /** 宛先種別 */
  type: number;
  /** 宛先 */
  targets: Array<any>;
  /** メッセージを同一利用者の家族間でシェアするか否か */
  isSharedMessages: boolean;
  /** タイトル */
  title: string;
  /** 本文 */
  text: string;
  /** 見ましたボタンをつけるか */
  addReadButton: boolean;
  /** 既読確認メッセージをつけるか */
  addOptionText: boolean;
  /** 返信ボタンをつけるか */
  addReplyButton: boolean;
  /** 添付ファイル */
  files: Array<File>;
  /** 入力時のプラン種別 */
  planType: PlanType;
  /** 値が格納してあるか */
  exist: boolean;
}

/**
 * ### MobileMessageRegister store
 *
 * - store
 *   - 新規送信画面の入力情報を保持する
 * - action, mutation
 *   - 新規送信画面の入力情報を格納する
 */
@Module({ name: "mobileMessageRegister" })
export default class MobileMessageRegister extends VuexModule implements MobileMessageRegisterState {
  type = -1;
  targets = [];
  isSharedMessages = false;
  title = "";
  text = "";
  addReadButton = false;
  addOptionText = false;
  addReplyButton = false;
  files = [];
  planType = PlanType.UNKNOWN;
  exist = false;

  /** stateのgetters */
  get mobileMessageRegisterState(): MobileMessageRegisterState {
    const state: MobileMessageRegisterState = {
      type: this.type,
      targets: this.targets,
      isSharedMessages: this.isSharedMessages,
      title: this.title,
      text: this.text,
      addReadButton: this.addReadButton,
      addOptionText: this.addOptionText,
      addReplyButton: this.addReplyButton,
      files: this.files,
      planType: this.planType,
      exist: this.exist
    };
    return state;
  }

  @Mutation
  private SET_MOBILEMESSAGEREGISTERSTATE(state: MobileMessageRegisterState) {
    this.type = state.type;
    this.targets = state.targets as never[];
    this.isSharedMessages = state.isSharedMessages;
    this.title = state.title;
    this.text = state.text;
    this.addReadButton = state.addReadButton;
    this.addOptionText = state.addOptionText;
    this.addReplyButton = state.addReplyButton;
    this.files = state.files as never[];
    this.planType = state.planType;
    this.exist = true;

    return;
  }

  @Mutation
  private RESET_MOBILEMESSAGEREGISTERSTATE() {
    this.type = -1;
    this.targets = [];
    this.isSharedMessages = false;
    this.title = "";
    this.text = "";
    this.addReadButton = false;
    this.addOptionText = false;
    this.addReplyButton = false;
    this.files = [];
    this.planType = PlanType.UNKNOWN;
    this.exist = false;

    return;
  }

  /**
   * ### 新規送信画面の入力情報を更新する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public updateMobileMessageRegisterState(payload: { state: MobileMessageRegisterState }): void {
    this.SET_MOBILEMESSAGEREGISTERSTATE(payload.state);

    return;
  }

  /**
   * ### 新規送信画面の入力情報を初期化する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public resetMobileMessageRegisterState(): void {
    this.RESET_MOBILEMESSAGEREGISTERSTATE();

    return;
  }
}
